import { useState } from "react";
import { Button, Offcanvas } from "react-bootstrap";

export default function FindingsDetailsOffCanvas({ chipData, index }) {
  const [showOffCanvas, setShowOffCanvas] = useState(false);

  return (
    <>
      <Button
        className='mt-auto'
        variant='outline-primary'
        onClick={() => setShowOffCanvas(true)}
      >
        More Details
      </Button>

      <Offcanvas
        show={showOffCanvas}
        onHide={() => setShowOffCanvas(false)}
        placement='start'
        scroll={true}
        backdrop={false}
      >
        <Offcanvas.Header
          closeButton
          className='pb-4'
          style={{ borderBottom: "0.3rem solid #e3803b" }}
        >
          <Offcanvas.Title>Chip {index + 1} Findings</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className='d-flex flex-column justify-content-center align-items-center gap-2 rounded shadow p-3 w-75 mx-auto border'>
            {chipData?.tests.map((scan, index) => {
              return (
                <div key={index} className='w-auto'>
                  <h6>
                    Round {scan.roundId}, Spot {scan.spotId}
                  </h6>
                  {scan.scanType === "BG" ? (
                    <p>Background Scan</p>
                  ) : scan.findings && scan.findings.length > 0 ? (
                    <ul>
                      {scan?.findings?.map((finding, index) => {
                        return <li key={index}>{finding.substance}</li>;
                      })}
                    </ul>
                  ) : (
                    <p>Inconclusive</p>
                  )}
                </div>
              );
            })}
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
